export enum KmatType {
  Main = "Main",
  SubRail = "Rail",
  SubCarriage = "Carriage",
}
